import { render, staticRenderFns } from "./Shopping.vue?vue&type=template&id=05b312a8&scoped=true"
import script from "./Shopping.vue?vue&type=script&lang=js"
export * from "./Shopping.vue?vue&type=script&lang=js"
import style0 from "./Shopping.vue?vue&type=style&index=0&id=05b312a8&prod&scoped=true&lang=css"
import style1 from "./Shopping.vue?vue&type=style&index=1&id=05b312a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b312a8",
  null
  
)

export default component.exports